import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=bcc8004c&scoped=true"
import script from "./Versions.vue?vue&type=script&lang=js"
export * from "./Versions.vue?vue&type=script&lang=js"
import style0 from "./Versions.vue?vue&type=style&index=0&id=bcc8004c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc8004c",
  null
  
)

export default component.exports